import { GameState } from "../Header/GameState";
import { ContentContainer } from "./GameTimelineContainer.styles";
import { useTimelinesStore } from "../Hooks/useTimelinesStore";
import {
    GAME_GENERAL_STATE,
    useGameGeneralState,
} from "../Hooks/useGameGeneralState";
import { BetDistributionSection } from "../BetDistribution/BetDistributionSection";

export function GameContentContainer({
    postId,
    isInPostDetails,
}: {
    isInPostDetails: boolean;
    postId: string;
}) {
    const { timeline: timelineList } = useTimelinesStore();
    const timeline = timelineList?.[postId];
    const gameState = useGameGeneralState(timeline);

    if (!timeline) {
        return <></>;
    }

    return (
        <ContentContainer isInPostDetails={isInPostDetails}>
            <GameState timeline={timeline} postId={postId} />
            {gameState !== GAME_GENERAL_STATE.NOT_STARTED && (
                <BetDistributionSection postId={postId} />
            )}
        </ContentContainer>
    );
}
